/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { fg } from '@atlassian/jira-feature-gating';
import VirtualAgentViewStandardFlowQuery from './__generated__/VirtualAgentViewStandardFlowQuery$parameters';
import type { VirtualAgentViewStandardFlowQuery as VirtualAgentViewStandardFlowQueryType } from './__generated__/VirtualAgentViewStandardFlowQuery.graphql';

type ViewStandardFlowEntryPointComponent = EntryPointComponent<
	{
		page: VirtualAgentViewStandardFlowQueryType;
	},
	{},
	{},
	{} | null
>;

export const viewStandardFlowEntryPoint: EntryPoint<
	ViewStandardFlowEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<ViewStandardFlowEntryPointComponent>(
		/* webpackChunkName: "async-virtual-agent-view-standard-flow" */ './VirtualAgentViewStandardFlow.tsx',
	),
	getPreloadProps: ({ context, tenantContext }: EntryPointRouteParams) => ({
		queries: {
			page: {
				parameters: VirtualAgentViewStandardFlowQuery,
				variables: {
					cloudId: tenantContext.cloudId,
					projectKey: context.match.params.projectKey ?? '',
					flowId: context.match.params.flowId ?? '',
					offerEscalationEnabled: fg('toggle_offer_escalation_standard_flow_feature') ?? false,
				},
			},
		},
	}),
});
